import React from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import {Button, Container, Spinner} from "reactstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faInfo,faTrash, faUserPlus, faUserEdit} from "@fortawesome/free-solid-svg-icons";
import ToolkitProvider, {Search, CSVExport} from 'react-bootstrap-table2-toolkit';
import paginationFactory from 'react-bootstrap-table2-paginator';
import {Col, Row} from "react-bootstrap";
import {connect} from 'react-redux';
import Moment from "react-moment";
import moment from "moment";
import {deleteCustomer, getAllCustomers, getAllOlderCustomers} from "../../actions/customerActions";
import Swal from "sweetalert2";
import  { Link, Redirect } from 'react-router-dom';
import {isMobile} from 'react-device-detect'
if (isMobile) { require('../customer.scss'); }

moment.locale('fr');


const {SearchBar } = Search;
const { ExportCSVButton } = CSVExport;


const handleClick = (dispatch, id) => {

    Swal.fire({
        title: "Êtes vous sur de vouloir supprimer ce client ?",
        icon: "warning",
        buttons: true,
        showCancelButton: true,
        confirmButtonText: `Ok`,
        denyButtonText: `Annuler`,
        dangerMode: true,
    })
        .then((willDelete) => {
            if (willDelete.isConfirmed) {
                dispatch(deleteCustomer(id))
                Swal.fire({
                    title: "Client supprimé avec succés",
                    text: "",
                    icon: "success"})
                    .then((result) => {
                        if(result.isConfirmed){
                                dispatch(getAllCustomers());
                                dispatch(getAllOlderCustomers());
                        }
                    });
            } else {
                Swal.fire("Le client est sauvegardé", "","info");
            }
        });
}



const defaultSorted = [{
    dataField: 'id',
    order: 'desc'
}]

const mapStateToProps = (state) => {
    return {
        getAllCustomers: state.customers.getAllCustomers,
        getAllOlderCustomers: state.customers.getAllOlderCustomers,
        isAuthenticated: state.auth.isAuthenticated,
        errorCustomersList: state.customers.errorCustomersList,
        errorTasksList: state.tasks.errorTasksList,
        loading: state.customers.loading
    }
}

const CustomerTableComponent = (props) => {
    const user = JSON.parse(localStorage.getItem('user'));
    if(!props.isAuthenticated){
        <Link to="/"/>
    }
    const options = {
        paginationSize: 4,
        pageStartIndex: 0,
        sizePerPageList: [{
            text: '50', value: 50
        },{
            text: '30', value: 30
        },{
            text: '25', value: 25
        }, {
            text: '10', value: 10
        }] // A numeric array is also available. the purpose of above example is custom the text
    };

    let getAllCustomers = [];
    const isOlderCustomer = props.isOlderCustomer;
    if(isOlderCustomer){
        getAllCustomers = props.getAllOlderCustomers;
    }else{
        getAllCustomers = props.getAllCustomers;
    }
    const columns = [
        {
            dataField: 'id',
            text: 'ID',
            sort: true,
            style: {
                overflow:"hidden",
                textOverflow: "ellipsis"
            },
            headerStyle: () => {
                return {
                    width: "7%",
                    overflow: "hidden",
                    textOverflow: "ellipsis"
                }
            },
        },
        {
            dataField: '_id',
            text: 'ID',
            sort: true,
            hidden: true,
            style: {
                overflow:"hidden",
                textOverflow: "ellipsis"
            },
            headerStyle: () => {
                return {
                    width: "20%",
                    overflow: "hidden",
                    textOverflow: "ellipsis"
                }
            },
        },
        {
            dataField: 'lastname',
            text: 'Nom',
            sort: true,
            style: {
                overflow:"hidden",
                textOverflow: "ellipsis"
            },
            headerStyle: () => {
                return {
                    width: "10%",
                    overflow: "hidden",
                    textOverflow: "ellipsis"};
            },
        },
        {
            dataField: 'firstname',
            text: 'Prenom',
            sort: true,
            style: {
                overflow:"hidden",
                textOverflow: "ellipsis"
            },
            headerStyle: () => {
                return {
                    width: "10%",
                    overflow: "hidden",
                    textOverflow: "ellipsis"};
            },
        },
        {
            dataField: 'email',
            text: 'Email',
            sort: true,
            maxLength: 10,
            style: {
                whiteSpace: "nowrap",
                overflow:"hidden",
                textOverflow: "ellipsis"
            },
            headerStyle: () => {
                return {
                    width: "13%",
                    overflow: "hidden",
                    textOverflow: "ellipsis"};
            },
            formatter: (rowContent, row) => {
                return (
                            <a href={"mailto:" + rowContent}>{rowContent}</a>
                )
            }
        },
        {
            dataField: 'phone',
            text: 'Téléphone',
            sort: true,
            maxLength: 10,
            style: {
                whiteSpace: "nowrap",
                overflow:"hidden",
                textOverflow: "ellipsis"
            },
            headerStyle: () => {
                return {
                    width: "13%",
                    overflow: "hidden",
                    textOverflow: "ellipsis"};
            },
            /*formatter: (rowContent, row) => {
                return (
                            <a href={"tel:" + rowContent}>{rowContent}</a>
                )
            }*/
        },
        {
            dataField: 'portable',
            text: 'Portable',
            sort: true,
            hidden: true,
            maxLength: 10,
            style: {
                whiteSpace: "nowrap",
                overflow:"hidden",
                textOverflow: "ellipsis"
            },
            headerStyle: () => {
                return {
                    width: "10%",
                    overflow: "hidden",
                    textOverflow: "ellipsis"};
            },
            /*formatter: (rowContent, row) => {
                return (
                            <a href={"tel:" + rowContent}>{rowContent}</a>
                )
            }*/
        },
        {
            dataField: 'website_url',
            text: 'Site internet',
            sort: true,
            maxLength: 10,
            style: {
                whiteSpace: "nowrap",
                overflow:"hidden",
                textOverflow: "ellipsis"
            },
            headerStyle: () => {
                return {
                    width: "13%",
                    overflow: "hidden",
                    textOverflow: "ellipsis"};
            },
            formatter: (rowContent, row) => {
                return (
                    <a href={"https://" + rowContent} target="_blank">{rowContent}</a>
                )
            }
        },
        {
            dataField: 'website_url_iweb',
            text: 'Url iweb',
            sort: true,
            hidden: true,
            maxLength: 10,
            style: {
                whiteSpace: "nowrap",
                overflow:"hidden",
                textOverflow: "ellipsis"
            },
            headerStyle: () => {
                return {
                    width: "13%",
                    overflow: "hidden",
                    textOverflow: "ellipsis"};
            },
            formatter: (rowContent, row) => {
                return (
                    <a href={rowContent} target="_blank">{rowContent}</a>
                )
            }
        },
        {
            dataField: 'ads_campaign_name',
            text: 'Nom de la campagne',
            sort: true,
            hidden: true,
            maxLength: 10,
            style: {
                whiteSpace: "nowrap",
                overflow:"hidden",
                textOverflow: "ellipsis"
            },
            headerStyle: () => {
                return {
                    width: "13%",
                    overflow: "hidden",
                    textOverflow: "ellipsis"};
            },
        },
        {
            dataField: 'password_iweb',
            text: 'Mot de passe iweb',
            sort: true,
            hidden: true,
            maxLength: 10,
            style: {
                whiteSpace: "nowrap",
                overflow:"hidden",
                textOverflow: "ellipsis"
            },
            headerStyle: () => {
                return {
                    width: "13%",
                    overflow: "hidden",
                    textOverflow: "ellipsis"};
            },
        },
        {
            dataField: 'company_name',
            text: 'Nom de société',
            sort: true,
            maxLength: 10,
            style: {
                whiteSpace: "nowrap",
                overflow:"hidden",
                textOverflow: "ellipsis"
            },
            headerStyle: () => {
                return {
                    width: "13%",
                    overflow: "hidden",
                    textOverflow: "ellipsis"};
            },
        },
        {
            dataField: 'register_date',
            text: 'Enregistré le',
            sort: true,
            hidden: true,
            style: {
                overflow:"hidden",
                textOverflow: "ellipsis"
            },
            formatter: (rowContent, row) => {
                const date = moment(rowContent).format('L');
                return (
                    date
                )
            }
        },
        {
            dataField: 'membership',
            text: 'Client/Prospect',
            sort: true,
            hidden: true,
            style: {
                width: "10%",
                overflow:"hidden",
                textOverflow: "ellipsis"
            },
            formatter: (rowContent, row) => {
                if(rowContent){
                    return (
                        "Client"
                    )
                }else{
                    return (
                        "Prospect"
                    )
                }
            },
            csvFormatter: (rowContent, row) => {
                if(rowContent){
                    return (
                        "Client"
                    )
                }else{
                    return (
                        "Prospect"
                    )
                }
            },
            headerStyle: () => {
                return {
                    width: "10%",
                    overflow: "hidden",
                    textOverflow: "ellipsis"};
            },
        },
        {
            dataField: 'user_id',
            text: 'Id du responsable',
            hidden: true,
            style: {
                overflow:"hidden",
                textOverflow: "ellipsis"
            },
        },
        {
            dataField: 'user_firstname',
            text: 'Prenom du responsable',
            sort: true,
            hidden: true,
            style: {
                overflow:"hidden",
                textOverflow: "ellipsis"
            },
            formatter: (rowContent, row) => {
                return (
                            row.user_firstname + ' ' + row.user_lastname
                )
            }
        },
        {
            dataField: 'user_lastname',
            text: 'Nom de famille du responsable',
            sort: true,
            hidden: true,
            style: {
                overflow:"hidden",
                textOverflow: "ellipsis"
            },
            formatter: (rowContent, row) => {
                return (
                    row.user_firstname + ' ' + row.user_lastname
                )
            }
        },
        {
            dataField: 'street',
            text: 'Rue',
            sort: true,
            hidden: true,
            style: {
                overflow:"hidden",
                textOverflow: "ellipsis"
            }
        },
        {
            dataField: 'zip',
            text: 'Code postal',
            sort: true,
            hidden: true,
            style: {
                overflow:"hidden",
                textOverflow: "ellipsis"
            }
        },
        {
            dataField: 'city',
            text: 'Ville',
            sort: true,
            hidden: true,
            style: {
                overflow:"hidden",
                textOverflow: "ellipsis"
            }
        },
        {
            dataField: 'state',
            text: 'Pays',
            sort: true,
            hidden: true,
            style: {
                overflow:"hidden",
                textOverflow: "ellipsis"
            }
        },
        {
            dataField: 'street_delivery',
            text: 'Rue de livraison',
            sort: true,
            hidden: true,
            style: {
                overflow:"hidden",
                textOverflow: "ellipsis"
            }
        },
        {
            dataField: 'zip_delivery',
            text: 'Code postal de livraison',
            sort: true,
            hidden: true,
            style: {
                overflow:"hidden",
                textOverflow: "ellipsis"
            }
        },
        {
            dataField: 'city_delivery',
            text: 'Ville de livraison',
            sort: true,
            hidden: true,
            style: {
                overflow:"hidden",
                textOverflow: "ellipsis"
            }
        },
        {
            dataField: 'state_delivery',
            text: 'Pays de livraison',
            sort: true,
            hidden: true,
            style: {
                overflow:"hidden",
                textOverflow: "ellipsis"
            }
        },
        {
            dataField: 'siret',
            text: 'Siret',
            sort: true,
            hidden: true,
            style: {
                overflow:"hidden",
                textOverflow: "ellipsis"
            }
        },
        {
            dataField: 'subscription_amount',
            text: 'Montant abonnement',
            sort: true,
            style: {
                overflow:"hidden",
                textOverflow: "ellipsis"
            },
            headerStyle: () => {
                return {
                    width: "10%",
                    overflow: "hidden",
                    textOverflow: "ellipsis"
                }
            },
        },
        {
            dataField: "link",
            text: "Action",
            csvExport: false,
            style: {
                overflow:"hidden",
                textOverflow: "ellipsis"
            },
            headerStyle: () => {
                return {
                    width: "16%",
                    overflow: "hidden",
                    textOverflow: "ellipsis"
                };
            },
            formatter: (rowContent, row) => {
                return (
                    <div>
                        <Link to={isOlderCustomer ? "detailOlderCustomer/" + row._id : "detailCustomer/" + row._id}>
                            <Button color="info" className="mr-2">
                                <FontAwesomeIcon icon={faInfo}/>
                            </Button>
                        </Link>
                            <Link to={isOlderCustomer ? "editOlderCustomer/" + row._id : "editCustomer/" + row._id}>
                                <Button color="warning" className="mr-2">
                                    <FontAwesomeIcon icon={faUserEdit}/>
                                </Button>
                            </Link>
                        {user?.role === 'admin' &&
                        <Button color="danger" className="mr-2" onClick={() => handleClick(props.dispatch,row._id, isOlderCustomer)}>
                            <FontAwesomeIcon icon={faTrash}/>
                        </Button>
                        }
                    </div>
                )
            }
        }
    ];

    return (
    <Container>
        <div>
            <h2>
                {isOlderCustomer ? 'Liste des anciens clients' : 'Liste des clients'}

                {/*({props.getAllCustomers.length})*/}
            </h2>
        </div>
        {
            getAllCustomers ?
            <ToolkitProvider
                bootstrap4
                keyField='_id'
                data={getAllCustomers}
                columns={columns}
                defaultSorted={defaultSorted}
                search={ {
                    searchFormatted: true,
                    defaultSearch: localStorage.getItem('searchTextCustomer')
                }}
                exportCSV={ {
                    fileName: isOlderCustomer ? 'AncienClients.csv' : 'Clients.csv',
                    onlyExportFiltered: true,
                    exportAll: false,
                    separator: ";"
                }}
            >
                {(props) => (
                    <div>
                        <Row>
                                <Col>
                                    <Link to={isOlderCustomer ? "createOlderCustomer" : "createCustomer"}>
                                        <Button color="primary" className="mr-2">
                                            <FontAwesomeIcon icon={faUserPlus}/>{isOlderCustomer ? 'Ajouter un ancien client' : 'Ajouter un client'}
                                        </Button>
                                    </Link>
                                    {
                                        /*
                                        user?.role === 'admin' &&
                                    <ExportCSVButton {...props.csvProps} className="mr-2">
                                        <Button color="info">
                                            Export au format CSV
                                        </Button>
                                    </ExportCSVButton>
                                         */
                                    }
                                </Col>
                            <Col>
                                <div className="float-right">
                                    <SearchBar {...props.searchProps} placeholder="Rechercher.."/>
                                    {localStorage.setItem('searchTextCustomer', props.searchProps.searchText)}
                                </div>
                            </Col>
                        </Row>
                        <BootstrapTable id="table-to-xls"
                                        striped
                                        hover
                                        printable
                                        wrapperClasses="table-responsive"
                                        bodyStyle={{overflow: 'overlay'}}
                                        {...props.baseProps} pagination={paginationFactory(options)}/>
                    </div>
                )}
            </ToolkitProvider> :
            (
                <div className="text-center">
                    {
                        props.errorCustomersList ? <h4>{props.errorCustomersList}</h4> :
                        <Spinner color="dark"/>
                    }
                    {
                        props.loading ? <Spinner color="dark"/> : null
                    }
                </div>
            )}
        <div className="text-center">
            {
                props.loading ? <Spinner color="dark"/> : null
            }
        </div>
    </Container>

)
};


export default connect(mapStateToProps, null)(CustomerTableComponent);